import { AuthErrorType, HeroImage, useOidcAuthentication } from '@cp-shared-19/frontend-ui';
import { withLoadingAndNoConnectionHandler } from 'components/integration-wrapper';
import React from 'react';
import { useCmsContent } from 'utils/useCmsContent';
import { useHistory } from 'react-router-dom';
import { getOidcErrorType } from 'auth';
import { GenericErrors } from 'cpnl-common/dist/apis/cms/types/generic-error';
import { dashboardPagePath, loginRedirectPagePath } from 'components/navigation/paths';

export const GenericError: React.FC = () => {
    const [cmsContent, isCmsLoading, cmsError] = useCmsContent<GenericErrors>('generic-error');
    const { logout } = useOidcAuthentication();
    const history = useHistory();
    const HeroImageWithHandlers = withLoadingAndNoConnectionHandler(HeroImage);
    const errorType = getOidcErrorType() || AuthErrorType.UNEXPECTED_ERR;

    const redirectUserBasedOnErrorType = async (error: AuthErrorType) => {
        switch (error) {
            case AuthErrorType.ALREADY_LOGIN_ERR:
                history.push(dashboardPagePath());
                break;
            default:
                logout({ post_logout_redirect_uri: window.location.origin + loginRedirectPagePath() });
                break;
        }
    };

    return (
        <HeroImageWithHandlers
            isLoading={isCmsLoading}
            hasError={!!cmsError}
            title={cmsContent && <div dangerouslySetInnerHTML={{ __html: cmsContent[errorType].title || '' }} />}
            buttonText={cmsContent && cmsContent[errorType].buttonText}
            clickHandler={async () => {
                await redirectUserBasedOnErrorType(errorType);
            }}
        />
    );
};
